import moment from "moment";

export const configSalesStructureAndComposition = [
    {name: "role", label: "\n", options: {sort: false}},
    {name: "lastMonth", label: "Last Month", options: {sort: true}},
    {name: "thisMonth", label: "This Month", options: {sort: true} },
    {name: "growth", label: "Growth", options: {sort: true, customBodyRender: (val) =>(`${val}%`)}},
    {name: "projection", label: "Proyeksi", options: {sort: false}},
    {name: "compositionLastMonth", label: "Komposisi\nLast Month", options: {sort: false, customBodyRender: (val) =>(`${val}%`)}},
    {name: "compositionThisMonth", label: "Komposisi\nThis Month", options: {sort: false, customBodyRender: (val) =>(`${val}%`)}},
];

export const getTableConfig = (tab, year) => {
    return tab === "mtd" ? configMonthToDate(year) : tab === "l3y" ? configLast3Years(year) : [];
};

const configMonthToDate = (year) => [
    {name: "name", label: "\n", options: {sort: false}},
    {name: 'january', label: "JAN", options: {sort: false}},
    {name: 'february', label: "FEB", options: {sort: false}},
    {name: 'march', label: "MAR", options: {sort: false}},
    {name: 'april', label: "APR", options: {sort: false}},
    {name: 'may', label: "MAY", options: {sort: false}},
    {name: 'june', label: "JUN", options: {sort: false}},
    {name: 'july', label: "JUL", options: {sort: false}},
    {name: 'august', label: "AUG", options: {sort: false}},
    {name: 'september', label: "SEP", options: {sort: false}},
    {name: 'october', label: "OCT", options: {sort: false}},
    {name: 'november', label: "NOV", options: {sort: false}},
    {name: 'december', label: "DEC", options: {sort: false}},
    {name: "totalPayment", label: year || moment().format("YYYY"), options: {sort: false}},
];

const configLast3Years = (val) => {
    const year = val ? Number(val) : Number(moment().format("YYYY"));
    return [
      { name: "role", label: "\n", options: { sort: false } },
      { name: "year2Quartal1", label: `Q1 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal2", label: `Q2 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal3", label: `Q3 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal4", label: `Q4 ${year - 2}`, options: { sort: false } },
      { name: "year1Quartal1", label: `Q1 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal2", label: `Q2 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal3", label: `Q3 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal4", label: `Q4 ${year - 1}`, options: { sort: false } },
      { name: "yearQuartal1", label: `Q1 ${year}`, options: { sort: false } },
      { name: "yearQuartal2", label: `Q2 ${year}`, options: { sort: false } },
      { name: "yearQuartal3", label: `Q3 ${year}`, options: { sort: false } },
      { name: "yearQuartal4", label: `Q4 ${year}`, options: { sort: false } },
    ]
};
